"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconOutlook = void 0;
var React = __importStar(require("react"));
var IconOutlook = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("defs", null,
        React.createElement("polygon", { id: "path-1", points: "0.404394059 0.011427 4.13099106 0.011427 4.13099106 4.20424106 0.404394059 4.20424106" }),
        React.createElement("polygon", { id: "path-3", points: "0.404394059 0.011427 4.13099106 0.011427 4.13099106 4.20424106 0.404394059 4.20424106" })),
    React.createElement("g", { id: "Social-/-ic_Outlook_c", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { id: "Padding", x: 0, y: 0, width: 24, height: 24 }),
        React.createElement("g", { id: "Outlook", transform: "translate(2.000000, 2.000000)" },
            React.createElement("rect", { id: "Background", fill: "#1E73BE", fillRule: "nonzero", x: 0, y: 0, width: 20, height: 20, rx: 2.35294118 }),
            React.createElement("polygon", { id: "Fill-1", fill: "#FFFFFF", fillRule: "nonzero", points: "11.7647059 2.94117647 3.52941176 4.48578805 3.52941176 15.5141626 11.7647059 17.0588235" }),
            React.createElement("path", { d: "M6.16124753,9.88033847 C6.16124753,10.6660231 6.62953553,11.3581066 7.38283247,11.3581066 C8.13764047,11.3581066 8.60431994,10.6473542 8.60431994,9.88033847 C8.60431994,9.14850647 8.16693588,8.40877612 7.38283247,8.40877612 C6.60920912,8.40882741 6.16124753,9.12209306 6.16124753,9.88033847 M7.37678818,12.115634 C6.15364335,12.115634 5.33507762,11.0121162 5.33507762,9.88033847 C5.33507762,8.72830188 6.19298018,7.64504288 7.39457988,7.64504288 C8.60246765,7.64504288 9.424543,8.77887212 9.424543,9.89275024 C9.424543,11.0704309 8.55557547,12.115634 7.37678818,12.115634", id: "Fill-2", fill: "#1E73BE", fillRule: "nonzero" }),
            React.createElement("g", { id: "Fill-4-Clipped", transform: "translate(12.352941, 5.882353)" },
                React.createElement("mask", { id: "mask-2", fill: "white" },
                    React.createElement("use", { xlinkHref: "#path-1" })),
                React.createElement("g", { id: "path-1" }),
                React.createElement("polygon", { id: "Fill-4", fill: "#FFFFFF", fillRule: "nonzero", mask: "url(#mask-2)", points: "4.13100565 0.011427 0.404394059 0.011427 0.404394059 4.20424106 4.13100565 0.910971529" })),
            React.createElement("g", { id: "Fill-7-Clipped", transform: "translate(12.352941, 5.882353)" },
                React.createElement("mask", { id: "mask-4", fill: "white" },
                    React.createElement("use", { xlinkHref: "#path-3" })),
                React.createElement("g", { id: "path-1" }),
                React.createElement("path", { d: "M0.404389176,5.31031835 L0.404389176,7.66357688 L4.13100076,7.66357688 L4.13100076,2.01704888 C3.37590029,2.68436024 0.404389176,5.31031835 0.404389176,5.31031835", id: "Fill-7", fill: "#FFFFFF", fillRule: "nonzero", mask: "url(#mask-4)" })))))); };
exports.IconOutlook = IconOutlook;
exports.IconOutlook.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconOutlook;
